export default __webpack_public_path__ + "static/media/img1.a51c6952.jpg";